export function getLocalTimeWithTimezone(): string
{
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const date = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const offset = now.getTimezoneOffset();
    const sign = offset <= 0 ? '+' : '-';
    const offsetHours = String(Math.abs(Math.floor(offset / 60))).padStart(2, '0');
    const offsetMinutes = String(Math.abs(offset % 60)).padStart(2, '0');

    return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
}
